import { ReactNode } from 'react'
import styled from 'styled-components'

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0;
  cursor: pointer;
`

IconContainer.displayName = 'IconContainer'

const MenuContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  background: ${({ theme }) => theme.palette.nswPaletteGrey04};
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`
MenuContainer.displayName = 'MenuContainer'

export default function Footer({ children }: { children: ReactNode }) {
  return <MenuContainer>{children}</MenuContainer>
}
